import Form from 'admin/components/Invoice/Form'
import Flash from 'admin/components/shared/Flash'
import useDocument from 'admin/hooks/useDocument'
import useEffect from 'admin/hooks/useEffect'
import useInvoice from 'admin/hooks/useInvoice'
import useStateObject from 'admin/hooks/useStateObject'
import React, {Fragment} from 'react'
import {useHistory, useParams} from 'react-router-dom'
import {NumberParam, useQueryParams} from 'use-query-params'
import {TAX_TYPES} from 'bundles/admin/lib/tax'
import useAccount from '../../hooks/useAccount'
import Header from '../shared/Header'

export default () => {
  const history = useHistory()
  const {organisationID} = useParams()
  const [{accountId}] = useQueryParams({accountId: NumberParam})
  const {account} = useAccount(organisationID, accountId)
  const {invoice, errors, create} = useInvoice(organisationID)
  const [form, setForm] = useStateObject({
    ...invoice,
    taxType: TAX_TYPES.inclusive
  })

  useDocument({title: 'New invoice'})

  useEffect(() => setForm(invoice), [invoice])
  useEffect(() => setForm({account, accountId}), [account])

  const handleCreate = e => {
    e.preventDefault()
    create(form, ({invoice}) => history.replace(`/orgs/${organisationID}/invoices/${invoice.id}`))
  }

  const breadcrumbs = []
  if (invoice.account?.id || account?.id) {
    breadcrumbs.push({
      label: 'Manage accounts',
      path: `/orgs/${organisationID}/accounts`
    })
    breadcrumbs.push({
      label: invoice.account?.displayName || account?.displayName,
      path: `/orgs/${organisationID}/accounts/${invoice.account?.id || account?.id}`
    })
  } else {
    breadcrumbs.push({
      label: 'Invoices',
      path: `/orgs/${organisationID}/invoices`
    })
  }

  return (
    <Fragment>
      <Flash />

      <Header breadcrumbs={breadcrumbs} title='New invoice'>
        <button className='button is-success' onClick={handleCreate}>
          Create
        </button>
      </Header>
      <section className='section'>
        <div className='container'>
          <Form errors={errors} organisationID={organisationID} invoice={form} onChange={setForm} />
        </div>
      </section>
    </Fragment>
  )
}
